{
  "egg": [],
  "bulbasaur": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "ivysaur": [
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "venusaur": [
    {
      "move": "growth",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgebomb",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "charmander": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "charmeleon": [
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "charizard": [
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "squirtle": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "wartortle": [
    {
      "move": "clamp",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "blastoise": [
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "caterpie": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    }
  ],
  "metapod": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    }
  ],
  "butterfree": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "weedle": [
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    }
  ],
  "kakuna": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    }
  ],
  "beedrill": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "pidgey": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "pidgeotto": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "pidgeot": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rattata": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raticate": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "spearow": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "fearow": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "wildcharge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ekans": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "arbok": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pikachu": [
    {
      "move": "spark",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raichu": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sandshrew": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "sandslash": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "nidoranf": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "nidorina": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "nidoqueen": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "nidoranm": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "nidorino": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "nidoking": [
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "clefairy": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "clefable": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "spotlight",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "vulpix": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "ninetales": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "jigglypuff": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wigglytuff": [
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "deflate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "zubat": [
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "golbat": [
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "oddish": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "gloom": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "vileplume": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "paras": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "parasect": [
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spore",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "venonat": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "venomoth": [
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "diglett": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "dugtrio": [
    {
      "move": "counter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "meowth": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "persian": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "payday",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "happyhour",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "payday",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "psyduck": [
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "golduck": [
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "mankey": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "primeape": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "growlithe": [
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "arcanine": [
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "poliwag": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "poliwhirl": [
    {
      "move": "dive",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "poliwrath": [
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "abra": [
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "kadabra": [
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "alakazam": [
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "machop": [
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "machoke": [
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "machamp": [
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bellsprout": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "weepinbell": [
    {
      "move": "wrap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "victreebel": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "swallow",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "tentacool": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "tentacruel": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "geodude": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "graveler": [
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "golem": [
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "ponyta": [
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "rapidash": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "slowpoke": [
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "slowbro": [
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "magnemite": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magneton": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "electricterrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "farfetchd": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "flyingpress",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "doduo": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "dodrio": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "seel": [
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "dewgong": [
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "grimer": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "muk": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "shellder": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "cloyster": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "gastly": [
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "haunter": [
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "deviouslick",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gengar": [
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "deviouslick",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "conjure",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "onix": [
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "drowzee": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hypno": [
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "pendulumwave",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "krabby": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "kingler": [
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "voltorb": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "electrode": [
    {
      "move": "discharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "exeggcute": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "exeggutor": [
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "cubone": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bonerush",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "marowak": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bonerush",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bonemerang",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hitmonlee": [
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hitmonchan": [
    {
      "move": "pummel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lickitung": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "deviouslick",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "koffing": [
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "weezing": [
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "noxiousgas",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "rhyhorn": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rhydon": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "chansey": [
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "softboiled",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tangela": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "kangaskhan": [
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "horsea": [
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "seadra": [
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonburst",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "goldeen": [
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "seaking": [
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "staryu": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "starmie": [
    {
      "move": "haze",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "mrmime": [
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "scyther": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "jynx": [
    {
      "move": "charm",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "psychoshift",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "electabuzz": [
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magmar": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "pinsir": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tauros": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magikarp": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    }
  ],
  "gyarados": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "lapras": [
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "ditto": [
    {
      "move": "transform",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "reflecttype",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "accustom",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "recycle",
      "how": "tutor"
    }
  ],
  "eevee": [
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "secretpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "synchronoise",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "lastresort",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "vaporeon": [
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "jolteon": [
    {
      "move": "commotion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "flareon": [
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "porygon": [
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "neuralyze",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "omanyte": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "omastar": [
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "reflecttype",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "kabuto": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "kabutops": [
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "aerodactyl": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "snorlax": [
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "lastresort",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "articuno": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "zapdos": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "moltres": [
    {
      "move": "firespin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "dratini": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "dragonair": [
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "dragonite": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "mew": [
    {
      "move": "transform",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "healpulse",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "accustom",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "reflecttype",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "imprison",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "chromosomecrush",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "frenzyplant",
      "how": "tutor"
    },
    {
      "move": "blastburn",
      "how": "tutor"
    },
    {
      "move": "hydrocannon",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "chikorita": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "bayleef": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "meganium": [
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "purify",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "cyndaquil": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "quilava": [
    {
      "move": "dig",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "typhlosion": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "totodile": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "croconaw": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "feraligatr": [
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "sentret": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "furret": [
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "hoothoot": [
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "noctowl": [
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ledyba": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "reflect",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "lightscreen",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ledian": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "reflect",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "lightscreen",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "spinarak": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    }
  ],
  "ariados": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spiderweb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "crobat": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "chinchou": [
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "lanturn": [
    {
      "move": "soak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "pichu": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    }
  ],
  "cleffa": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "igglybuff": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "togepi": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "togetic": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "natu": [
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "xatu": [
    {
      "move": "haze",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "miracleeye",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "mareep": [
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    }
  ],
  "flaaffy": [
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "ampharos": [
    {
      "move": "electrify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "bellossom": [
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "purify",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "marill": [
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "azumarill": [
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "sudowoodo": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "politoed": [
    {
      "move": "hop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "hoppip": [
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "skiploom": [
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "jumpluff": [
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "aipom": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sunkern": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "sunflora": [
    {
      "move": "ignite",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "yanma": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wooper": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "quagsire": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "espeon": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "umbreon": [
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "murkrow": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "slowking": [
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "misdreavus": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "unown": [
    {
      "move": "hiddenpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "secretpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    }
  ],
  "wobbuffet": [
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "girafarig": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pineco": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "forretress": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "dunsparce": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "secretpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "gligar": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "steelix": [
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "snubbull": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "granbull": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "qwilfish": [
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "deflate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "scizor": [
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shuckle": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "heracross": [
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "sneasel": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "teddiursa": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ursaring": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "slugma": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "magcargo": [
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "swinub": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "piloswine": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "corsola": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "remoraid": [
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "octillery": [
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "delibird": [
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "celebrate",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "present",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "mantine": [
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "skarmory": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "houndour": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "houndoom": [
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "kingdra": [
    {
      "move": "yawn",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonburst",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "phanpy": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "donphan": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "porygon2": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "stantler": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "smeargle": [
    {
      "move": "sketch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "imprison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 64
    },
    {
      "move": "sketch",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    },
    {
      "move": "frenzyplant",
      "how": "tutor"
    },
    {
      "move": "blastburn",
      "how": "tutor"
    },
    {
      "move": "hydrocannon",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "tyrogue": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hitmontop": [
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "smoochum": [
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "elekid": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magby": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "miltank": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "milkdrink",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "blissey": [
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "softboiled",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raikou": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "entei": [
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "suicune": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "sheercold",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "larvitar": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pupitar": [
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "tyranitar": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "lugia": [
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hooh": [
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 64
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "celebi": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "treecko": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "grovyle": [
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "sceptile": [
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "torchic": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "combusken": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "blaziken": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "mudkip": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "marshtomp": [
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "swampert": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "poochyena": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "mightyena": [
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "zigzagoon": [
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "linoone": [
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wurmple": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    }
  ],
  "silcoon": [
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    }
  ],
  "beautifly": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "cascoon": [
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    }
  ],
  "dustox": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lotad": [
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "lombre": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "ludicolo": [
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "seedot": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "nuzleaf": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "shiftry": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "taillow": [
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "swellow": [
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wingull": [
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "pelipper": [
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "swallow",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "ralts": [
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "kirlia": [
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gardevoir": [
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "surskit": [
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "masquerain": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "shroomish": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "breloom": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spore",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "slakoth": [
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "icefang",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "vigoroth": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "slaking": [
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "nincada": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    }
  ],
  "ninjask": [
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shedinja": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "whismur": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "loudred": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "exploud": [
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "makuhita": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "hariyama": [
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "matblock",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "azurill": [
    {
      "move": "ignite",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "nosepass": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "skitty": [
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "delcatty": [
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sableye": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mawile": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "aron": [
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "lairon": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "aggron": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "meditite": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "medicham": [
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "electrike": [
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "manectric": [
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "plusle": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    }
  ],
  "minun": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    }
  ],
  "volbeat": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "illumise": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "roselia": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "gulpin": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    }
  ],
  "swalot": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "swallow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    }
  ],
  "carvanha": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "sharpedo": [
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "wailmer": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "wailord": [
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "numel": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "camerupt": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "torkoal": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "shelltrap",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "noxiousgas",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "spoink": [
    {
      "move": "hop",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "grumpig": [
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "spinda": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "spotlight",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "trapinch": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "vibrava": [
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "flygon": [
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "synchronoise",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "cacnea": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "cacturne": [
    {
      "move": "punishment",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "rototiller",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "swablu": [
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "altaria": [
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "zangoose": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 67
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "seviper": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lunatone": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "solrock": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "barboach": [
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "whiscash": [
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fissure",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "corphish": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "crawdaunt": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "baltoy": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "claydol": [
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "lileep": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "cradily": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "anorith": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "armaldo": [
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "feebas": [
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "milotic": [
    {
      "move": "coil",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "castform": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "steameruption",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "kecleon": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "secretpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "shuppet": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "banette": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "grudge",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "duskull": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "dusclops": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tropius": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "chimecho": [
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "craftyshield",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "absol": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wynaut": [
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "safeguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "snorunt": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "glalie": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "spheal": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "sealeo": [
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "walrein": [
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "clamperl": [
    {
      "move": "clamp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "huntail": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "gorebyss": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "relicanth": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "luvdisc": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "bagon": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "shelgon": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "salamence": [
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "beldum": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "metang": [
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "metagross": [
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "regirock": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "regice": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    }
  ],
  "registeel": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "latias": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "reflecttype",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "latios": [
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "jirachi": [
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "deoxys": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "turtwig": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "grotle": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "torterra": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "rototiller",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "chimchar": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "monferno": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "infernape": [
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "piplup": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "prinplup": [
    {
      "move": "dive",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "empoleon": [
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "starly": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "staravia": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "staraptor": [
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bidoof": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "bibarel": [
    {
      "move": "dive",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "kricketot": [
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    }
  ],
  "kricketune": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shinx": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    }
  ],
  "luxio": [
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "luxray": [
    {
      "move": "howl",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "budew": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "roserade": [
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "cranidos": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rampardos": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shieldon": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "bastiodon": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "burmy": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    }
  ],
  "wormadam": [
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "mothim": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "combee": [
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    }
  ],
  "vespiquen": [
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "healorder",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "defendorder",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "attackorder",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "pachirisu": [
    {
      "move": "hop",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "buizel": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "floatzel": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "cherubi": [
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "cherrim": [
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "shellos": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "gastrodon": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "ambipom": [
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "drifloon": [
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "drifblim": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "deflate",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "buneary": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lopunny": [
    {
      "move": "stomp",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "mismagius": [
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "honchkrow": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "glameow": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "purugly": [
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "chingling": [
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "stunky": [
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "skuntank": [
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "noxiousgas",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bronzor": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bronzong": [
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bonsly": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mimejr": [
    {
      "move": "copycat",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "happiny": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "chatot": [
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "spiritomb": [
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "gible": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "gabite": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "garchomp": [
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "munchlax": [
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "riolu": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lucario": [
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "shadowbone",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hippopotas": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "hippowdon": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "skorupi": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "drapion": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "croagunk": [
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "toxicroak": [
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "carnivine": [
    {
      "move": "growth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "finneon": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "lumineon": [
    {
      "move": "haze",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "mantyke": [
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "snover": [
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "abomasnow": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "weavile": [
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magnezone": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lickilicky": [
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "deviouslick",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "swallow",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "rhyperior": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tangrowth": [
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "electivire": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "magmortar": [
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "togekiss": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "yanmega": [
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "leafeon": [
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "glaceon": [
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gliscor": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mamoswine": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "porygonz": [
    {
      "move": "multiattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "multiattack",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gallade": [
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "probopass": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "dusknoir": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "froslass": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rotom": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "uxie": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "mesprit": [
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "azelf": [
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "heatran": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "regigigas": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "crushgrip",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "fissure",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "giratina": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "cresselia": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "phione": [
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "manaphy": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "darkrai": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "darkvoid",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shaymin": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "purify",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "victini": [
    {
      "move": "ignite",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 67
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 67
    },
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    },
    {
      "move": "blastburn",
      "how": "tutor"
    }
  ],
  "snivy": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "servine": [
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "serperior": [
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "tepig": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "pignite": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "emboar": [
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "oshawott": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "dewott": [
    {
      "move": "assurance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "samurott": [
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "patrat": [
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "watchog": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lillipup": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "herdier": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "stoutland": [
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "purrloin": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    }
  ],
  "liepard": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "pansage": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "simisage": [
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "pansear": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "simisear": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "panpour": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "simipour": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "steameruption",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "munna": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "musharna": [
    {
      "move": "yawn",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "pidove": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tranquill": [
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "unfezant": [
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "blitzle": [
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "zebstrika": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "roggenrola": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rocktomb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "boldore": [
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gigalith": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "woobat": [
    {
      "move": "flatter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "swoobat": [
    {
      "move": "befriend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "flatter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "drilbur": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "excadrill": [
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "drillrun",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "horndrill",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "audino": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "synchronoise",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "timburr": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gurdurr": [
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "conkeldurr": [
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tympole": [
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "palpitoad": [
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "seismitoad": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "throh": [
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "matblock",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sawk": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sewaddle": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "swadloon": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "leavanny": [
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "entrainment",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "venipede": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "whirlipede": [
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "scolipede": [
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "megahorn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "cottonee": [
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "whimsicott": [
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "petilil": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "lilligant": [
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "purify",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "basculin": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "sandile": [
    {
      "move": "embargo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "krokorok": [
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "embargo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "krookodile": [
    {
      "move": "embargo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "darumaka": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "darmanitan": [
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "maractus": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "rototiller",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "dwebble": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "crustle": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "scraggy": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "scrafty": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "sigilyph": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychoshift",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "yamask": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "cofagrigus": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "tirtouga": [
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "carracosta": [
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "archen": [
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "archeops": [
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "trubbish": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "garbodor": [
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "zorua": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "partingshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "zoroark": [
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "minccino": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "cinccino": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gothita": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "gothorita": [
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gothitelle": [
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "solosis": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "duosion": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "reuniclus": [
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ducklett": [
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "swanna": [
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "vanillite": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "vanillish": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "vanilluxe": [
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "sheercold",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "deerling": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "sawsbuck": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "emolga": [
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "karrablast": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "escavalier": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "drillpeck",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "foongus": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "amoonguss": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spore",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "frillish": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "conjure",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "jellicent": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "alomomola": [
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "joltik": [
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    }
  ],
  "galvantula": [
    {
      "move": "spark",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "spiderweb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "ferroseed": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "ferrothorn": [
    {
      "move": "constrict",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "klink": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "klang": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "geargrind",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "gearup",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "shiftgear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "klinklang": [
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "geargrind",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "gearup",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "shiftgear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "tynamo": [
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    }
  ],
  "eelektrik": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "eelektross": [
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "wrap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "elgyem": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "neuralyze",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "beheeyem": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healblock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "litwick": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "lampent": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "chandelure": [
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "ominouswind",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "axew": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "fraxure": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "guillotine",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "haxorus": [
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "cubchoo": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "beartic": [
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "cryogonal": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "shelmet": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    }
  ],
  "accelgor": [
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "stunfisk": [
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "mienfoo": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "mienshao": [
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "druddigon": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "golett": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "golurk": [
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pawniard": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bisharp": [
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "bouffalant": [
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rufflet": [
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "braviary": [
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "flyingpress",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "vullaby": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mandibuzz": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "heatmor": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "durant": [
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "deino": [
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "zweilous": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "hydreigon": [
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dracojet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonburst",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 59
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    },
    {
      "move": "dragonascent",
      "how": "tutor"
    }
  ],
  "larvesta": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "volcarona": [
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "cobalion": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "terrakion": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "virizion": [
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "frenzyplant",
      "how": "tutor"
    }
  ],
  "tornadus": [
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "thundurus": [
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "landorus": [
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "kyurem": [
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "keldeo": [
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "meloetta": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "genesect": [
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "multiattack",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "shiftgear",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "chespin": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "quilladin": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "chesnaught": [
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "vinelashes",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "fennekin": [
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "braixen": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "delphox": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "froakie": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "frogadier": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "greninja": [
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "bunnelby": [
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "diggersby": [
    {
      "move": "stomp",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "fletchling": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "fletchinder": [
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "talonflame": [
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skydrop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "scatterbug": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    }
  ],
  "spewpa": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    }
  ],
  "vivillon": [
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "accustom",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "litleo": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "pyroar": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "blazingoutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "flabebe": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "floette": [
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "florges": [
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "floralguard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "skiddo": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "gogoat": [
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "pancham": [
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "pangoro": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "karatechop",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "furfrou": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "espurr": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "meowstic": [
    {
      "move": "charm",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "honedge": [
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "doublade": [
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "aegislash": [
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "powertrick",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "kingsshield",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "spritzee": [
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "aromatisse": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "swirlix": [
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "slurpuff": [
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "copycat",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    }
  ],
  "inkay": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "malamar": [
    {
      "move": "glare",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "simplebeam",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "nightmare",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "binacle": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "barbaracle": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smellingsalts",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "skrelp": [
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    }
  ],
  "dragalge": [
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "clauncher": [
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "clawitzer": [
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "helioptile": [
    {
      "move": "electrify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "heliolisk": [
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "tyrunt": [
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "tyrantrum": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "amaura": [
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "aurorus": [
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "ancientforce",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    }
  ],
  "sylveon": [
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "hawlucha": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "flyingpress",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "dedenne": [
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "carbink": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "goomy": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "sliggoo": [
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "goodra": [
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "poisontail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "klefki": [
    {
      "move": "torment",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fairylock",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "phantump": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "trevenant": [
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "forestscurse",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "pumpkaboo": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "gourgeist": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "trick",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 4
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 6
    },
    {
      "move": "worryseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "painsplit",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "bergmite": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "icefang",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "avalugg": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "noibat": [
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "synchronoise",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "belch",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "noivern": [
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "zygarde": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "thousandwaves",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "thousandarrows",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "coreenforcer",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "diancie": [
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "hoopa": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 64
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "hyperspacefury",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "volcanion": [
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "scald",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "snipeshot",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "steameruption",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "waterspout",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "rowlet": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "dartrix": [
    {
      "move": "growth",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "decidueye": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spiritshackle",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "litten": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "torracat": [
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "incineroar": [
    {
      "move": "timeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "timeout",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "popplio": [
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "brionne": [
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "primarina": [
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mistyterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "perishsong",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "pikipek": [
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "trumbeak": [
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "peck",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "toucannon": [
    {
      "move": "beakblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "supersonic",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "mirrormove",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "dualwingbeat",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "beakblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "furypecks",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "yungoos": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "gumshoos": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "investigate",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "grubbin": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "charjabug": [
    {
      "move": "recharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "vikavolt": [
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "crabrawler": [
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "crabominable": [
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seismictoss",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "clamp",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "icehammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "oricorio": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "cutiefly": [
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "ribombee": [
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "rockruff": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lycanroc": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "lastresort",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wishiwashi": [
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "mareanie": [
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "toxapex": [
    {
      "move": "toxic",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "mudbray": [
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mudsdale": [
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "dewpider": [
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "araquanid": [
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spiderweb",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "fomantis": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "lurantis": [
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "morelull": [
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "shiinotic": [
    {
      "move": "wish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spotlight",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spore",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "salandit": [
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "salazzle": [
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "stufful": [
    {
      "move": "holdback",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "bewear": [
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "bounsweet": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "steenee": [
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "tsareena": [
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "hop",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "stomp",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "lowsweep",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "comfey": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "charmingkiss",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "oranguru": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "meditate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "instruct",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "passimian": [
    {
      "move": "timeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wimpod": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "golisopod": [
    {
      "move": "firstimpression",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "firstimpression",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "razorshell",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "sandygast": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "palossand": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "pyukumuku": [
    {
      "move": "bide",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "purify",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "typenull": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "silvally": [
    {
      "move": "multiattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "return",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "multiattack",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "technoblast",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "komala": [
    {
      "move": "yawn",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "secretpower",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "sleeptalk",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "lastresort",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "fling",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "turtonator": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "burningbarrage",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "eruption",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shelltrap",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "dragonburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "togedemaru": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "mimikyu": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "bruxish": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dreamykiss",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "drampa": [
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "harmonize",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "serenade",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "dhelmise": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "constrict",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "anchorshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "jangmoo": [
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "hakamoo": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "kommoo": [
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "tapukoko": [
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bravebird",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "tapulele": [
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "tapubulu": [
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "tapufini": [
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "cosmog": [
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magiccoat",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "cosmoem": [
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magiccoat",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "solgaleo": [
    {
      "move": "solarstrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "morningsun",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lunala": [
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "nihilego": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "buzzwole": [
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "circlethrow",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "knockoutpunch",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "wakeupslap",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pheromosa": [
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triplekick",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "xurkitree": [
    {
      "move": "constrict",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 64
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "electrooutburst",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "celesteela": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shiftgear",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "kartana": [
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "falsestrike",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "guzzlord": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "heatcrash",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "crabhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "necrozma": [
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "magearna": [
    {
      "move": "fortify",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "shiftgear",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "marshadow": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "forcepalm",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "rollingkick",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "forcewaves",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "highjumpkick",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "poipole": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    }
  ],
  "naganadel": [
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "toxicthread",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "needlebash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "crosspoison",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "stakataka": [
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "wideguard",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powerswap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "guardswap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "powersplit",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "guardsplit",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mesmereyes",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "blacephalon": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mindblown",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "zeraora": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "machpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "deoxysattack": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "deoxysdefense": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "deoxysspeed": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "meteormash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "wormadamsandy": [
    {
      "move": "dig",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "fissure",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "wormadamtrash": [
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisonpowder",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "cottonspore",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "giratinaorigin": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonascent",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "rotomheat": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "rotomwash": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "rotomfrost": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "rotomfan": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "commotion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "rotommow": [
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "shelloseast": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "gastrodoneast": [
    {
      "move": "belch",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "mudsport",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "basculinbluestriped": [
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dive",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "muddywater",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "keldeoresolute": [
    {
      "move": "vacuumwave",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "highhorsepower",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "sacredsword",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "surgingstrikes",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "tornadustherian": [
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aerialace",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "thundurustherian": [
    {
      "move": "swift",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "landorustherian": [
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "mudshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "fly",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "meowsticf": [
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "psychup",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "barrier",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "furfrouheart": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroustar": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroudiamond": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroudebutante": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroumatron": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroudandy": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroulareine": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroukabuki": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "furfroupharaoh": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "doublekick",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cottonguard",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "pumpkaboosmall": [
    {
      "move": "trick",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 4
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 6
    },
    {
      "move": "worryseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "painsplit",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "pumpkaboolarge": [
    {
      "move": "trick",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 4
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 6
    },
    {
      "move": "worryseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "painsplit",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "pumpkaboosuper": [
    {
      "move": "trick",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 4
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 6
    },
    {
      "move": "worryseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "painsplit",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "gourgeistsmall": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "forestscurse",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "gourgeistlarge": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "trick",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 4
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 6
    },
    {
      "move": "worryseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "shadowball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "painsplit",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "seedbomb",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "gourgeistsuper": [
    {
      "move": "explosion",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "confuseray",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "soulabsorb",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "destinybond",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "spectrify",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "forestscurse",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "floetteeternal": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "petaldance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "grasswhistle",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "radiantoutburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "timeout",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "hoopaunbound": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thinkfast",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dizzypunches",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "doomdesire",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "hocuspocus",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "spectralbeam",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 62
    },
    {
      "move": "psychowarp",
      "how": "lvl",
      "level": 64
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 66
    },
    {
      "move": "oblivionbeam",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "hyperspacefury",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "oricoriopompom": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "oricoriopau": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "oricoriosensu": [
    {
      "move": "tickle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "featherdance",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "gust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "featherball",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "teeterdance",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "luckychant",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "razorwind",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "sing",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "skyattack",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ],
  "lycanrocmidnight": [
    {
      "move": "laceration",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "brutalswing",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "stormthrow",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lycanrocdusk": [
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "jaggededge",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "howl",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "submission",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "rattataalola": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "embargo",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raticatealola": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "embargo",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raticatealolatotem": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tailwag",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "embargo",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "assurance",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pluck",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "mefirst",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "beatup",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "finalgambit",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "raichualola": [
    {
      "move": "influx",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "doubleslap",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "echoedvoice",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "tickle",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "whiplash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psychicterrain",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "storedpower",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "psystrike",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "sandshrewalola": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "sandslashalola": [
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "iceshard",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "bulletpunch",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "iceball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "furycutter",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "icebreaker",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "avalanche",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "iciclecrash",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "glacialbarrage",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "vulpixalola": [
    {
      "move": "encore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "ninetalesalola": [
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "mist",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "frostflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "icywind",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "healingwish",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "futuresight",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "radiantedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "frostbreath",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "dreameater",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "enchantment",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "meowthalola": [
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "persianalola": [
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "switcheroo",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "swift",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "swagger",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "tailslap",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "furyswipes",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "confide",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "hypnosis",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "happyhour",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "assist",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "payday",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "geodudealola": [
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "graveleralola": [
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "electrify",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "golemalola": [
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rollout",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "accelerock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "heavyslam",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "bodyslam",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "magneticburst",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "boulderbash",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "withdraw",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "grimeralola": [
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mukalola": [
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "harden",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "nightburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisondart",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "thief",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "dismalcry",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "barbbarrage",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "recover",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "punishment",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "banefulbunker",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "nightdaze",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "acidarmor",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "hammerarm",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "twilightcannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wickedblow",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "payback",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "counter",
      "how": "lvl",
      "level": 61
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "exeggutoralola": [
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "influx",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "bulletseed",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "confusion",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "extrasensory",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "triattack",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "eggcannon",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "speedswap",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "tropkick",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "triplecannonade",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "growth",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "branchleech",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "dragonhammer",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "dragonburst",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "marowakalola": [
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bonerush",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "tearfullook",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "shadowbone",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bonemerang",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "marowakalolatotem": [
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "focusenergy",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "defensecurl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bonerush",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "quickguard",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "wish",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikes",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "skirmish",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "pyrodash",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "spook",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "ragingfury",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "fierydance",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "shadowbone",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "firelash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boneclub",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "cometpunch",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "pummel",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "mindreader",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "infernalparade",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "bonemerang",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "flareblitz",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "lunardance",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "flamewheel",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "blazingassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "zygarde10": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "thousandwaves",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "thousandarrows",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "coreenforcer",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "zygarde50": [
    {
      "move": "recover",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "twister",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "breakingswipe",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "hyperspeed",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "extremespeed",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "coil",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "landswrath",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "powerglow",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "dragonrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "thousandwaves",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "thousandarrows",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "coreenforcer",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "bind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "miniorred": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "psyshock",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "psychoboost",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "subspacetear",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "miniororange": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "detonate",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "minioryellow": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "miniorgreen": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "miniorblue": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezerburn",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "freezedry",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "glaciate",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    }
  ],
  "miniorindigo": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "miniorviolet": [
    {
      "move": "cosmicchaos",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "moonlight",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ancientpower",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "cosmicpower",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "powergem",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "explosion",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragonbreath",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "mineralshower",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "dracometeor",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "shellsmash",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "diglettalola": [
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "magnitude",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "dugtrioalola": [
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "metalclaw",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "rockblast",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "sedimend",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "detect",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "smackdown",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "memento",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "doubleedge",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "rockwrecker",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "precipiceblades",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "headsmash",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "headlongrush",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "mimikyutotem": [
    {
      "move": "spook",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "shadowsneak",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "faerieblow",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "babydolleyes",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "playnice",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "trickroom",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "topsyturvy",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "woodhammer",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "phantomforce",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "kerfuffle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "spectralthief",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "shadowforce",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "mimic",
      "how": "lvl",
      "level": 65
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "spitefulspell",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    }
  ],
  "gumshoostotem": [
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "growl",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "odorsleuth",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "quickattack",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pursuit",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "fakeout",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "slackoff",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "shadowclaw",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "yawn",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "flail",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "investigate",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "hyperfang",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "powertrip",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "block",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "vikavolttotem": [
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "vicegrip",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "molt",
      "how": "lvl",
      "level": 8
    },
    {
      "move": "mudfling",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "dig",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "thundershock",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "paraboliccharge",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "jaggedfangs",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "discharge",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "mudbomb",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "divebomb",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "electroball",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "aeroblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "zapcannon",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "plasmashot",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "lockon",
      "how": "lvl",
      "level": 57
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "drillrun",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "lurantistotem": [
    {
      "move": "leechseed",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "floralhealing",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leafflurry",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "seedshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "razorleaf",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "magicalleaf",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "slash",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "ingrain",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "nightslash",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "xscissor",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "psychocut",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "camouflage",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "crosschop",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "laceration",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leafblade",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "petalblizzard",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "acclimate",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "superpower",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "seedflare",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "chloroblast",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "leafstorm",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "frenzyplant",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "seedbomb",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "synthesis",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "worryseed",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "grasspledge",
      "how": "tutor"
    }
  ],
  "salazzletotem": [
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "poisongas",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "ignite",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "sludgeshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "torment",
      "how": "lvl",
      "level": 7
    },
    {
      "move": "smog",
      "how": "lvl",
      "level": 9
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "disable",
      "how": "lvl",
      "level": 11
    },
    {
      "move": "firespin",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "sludgefling",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 17
    },
    {
      "move": "flameburst",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "faketears",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "glare",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "toxic",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "venomdrench",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "scumshot",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "clearsmog",
      "how": "lvl",
      "level": 29
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "pyroplume",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "acidspray",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "burnup",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "inferno",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "searingshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "blastburn",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "firevortex",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "overheat",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "snatch",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "firepledge",
      "how": "tutor"
    }
  ],
  "kommoototem": [
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skyuppercut",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "autotomize",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "tackle",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 15
    },
    {
      "move": "protect",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "leer",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "bide",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "protect",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "dragontail",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "scaryface",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "headbutt",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "workup",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "screech",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "irondefense",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "dragonclaw",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "battlecry",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "dragondance",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "outrage",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "closecombat",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "boomburst",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "mirrorshot",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "roar",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "uproar",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "dragonfury",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "drakonicwave",
      "how": "lvl",
      "level": 55
    },
    {
      "move": "bellydrum",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "drakonicbeam",
      "how": "lvl",
      "level": 70
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "poweruppunch",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "megatonkick",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "powerwhip",
      "how": "tm"
    },
    {
      "move": "brickbreak",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "blazekick",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "dracojet",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "lowkick",
      "how": "tutor"
    },
    {
      "move": "uproar",
      "how": "tutor"
    },
    {
      "move": "thunderpunch",
      "how": "tutor"
    },
    {
      "move": "firepunch",
      "how": "tutor"
    },
    {
      "move": "icepunch",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "aquatail",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "drainpunch",
      "how": "tutor"
    },
    {
      "move": "focuspunch",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "dracometeor",
      "how": "tutor"
    }
  ],
  "necrozmaduskmane": [
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "firefang",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "flamethrower",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "superpower",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "necrozmadawnwings": [
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "dragondance",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "closecombat",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "fireblast",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "mysticalfire",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "steelwing",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "megahorn",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "hail",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "auroraveil",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "bulldoze",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "roost",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "painsplit",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    }
  ],
  "necrozmaultra": [
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "earthquake",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "solarblade",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "scorchingsands",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "burningmalice",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "willowisp",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "ominouswind",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "shadowpunch",
      "how": "tm"
    },
    {
      "move": "seismicfist",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "sandstorm",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "thunderfang",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "hex",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "strength",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "shadowball",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "earthpower",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "dragonpulse",
      "how": "tutor"
    },
    {
      "move": "hypervoice",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "knockoff",
      "how": "tutor"
    },
    {
      "move": "heatwave",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "outrage",
      "how": "tutor"
    },
    {
      "move": "recycle",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    }
  ],
  "araquanidtotem": [
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stringshot",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "infestation",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "bubbleshot",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "bubblebarrage",
      "how": "lvl",
      "level": 13
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "brine",
      "how": "lvl",
      "level": 19
    },
    {
      "move": "rehydrate",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "soak",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "watersport",
      "how": "lvl",
      "level": 25
    },
    {
      "move": "aurorabeam",
      "how": "lvl",
      "level": 27
    },
    {
      "move": "creepingstrike",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "aquajet",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "skittersmack",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "crunch",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "spewout",
      "how": "lvl",
      "level": 31
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "leechlife",
      "how": "lvl",
      "level": 35
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 37
    },
    {
      "move": "torrentialpulse",
      "how": "lvl",
      "level": 39
    },
    {
      "move": "haze",
      "how": "lvl",
      "level": 41
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 43
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "bubbleburst",
      "how": "lvl",
      "level": 47
    },
    {
      "move": "spiderweb",
      "how": "lvl",
      "level": 49
    },
    {
      "move": "hydrocannon",
      "how": "lvl",
      "level": 51
    },
    {
      "move": "wavecrash",
      "how": "lvl",
      "level": 53
    },
    {
      "move": "whirlpool",
      "how": "lvl",
      "level": 58
    },
    {
      "move": "mirrorcoat",
      "how": "lvl",
      "level": 63
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "psychicfangs",
      "how": "tm"
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "icefang",
      "how": "tm"
    },
    {
      "move": "venoshock",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "icebeam",
      "how": "tm"
    },
    {
      "move": "blizzard",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "sludgebomb",
      "how": "tm"
    },
    {
      "move": "sludgewave",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "hydropump",
      "how": "tm"
    },
    {
      "move": "honeclaws",
      "how": "tm"
    },
    {
      "move": "belch",
      "how": "tm"
    },
    {
      "move": "darkpulse",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "surf",
      "how": "tm"
    },
    {
      "move": "poisonfang",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "rage",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "magiccoat",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "icywind",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "waterpulse",
      "how": "tutor"
    },
    {
      "move": "acidreflux",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "liquidation",
      "how": "tutor"
    },
    {
      "move": "hellthrust",
      "how": "tutor"
    },
    {
      "move": "laserfocus",
      "how": "tutor"
    },
    {
      "move": "waterpledge",
      "how": "tutor"
    }
  ],
  "togedemarutotem": [
    {
      "move": "spikes",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "nuzzle",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spikyshield",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "spark",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "gyroball",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "encore",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "holdback",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "rapidspin",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "hoodwink",
      "how": "lvl",
      "level": 18
    },
    {
      "move": "spikecannon",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "pinmissile",
      "how": "lvl",
      "level": 20
    },
    {
      "move": "recharge",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "fortify",
      "how": "lvl",
      "level": 22
    },
    {
      "move": "metalsound",
      "how": "lvl",
      "level": 24
    },
    {
      "move": "superfang",
      "how": "lvl",
      "level": 26
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strangeimpulse",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "zingzap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "reversal",
      "how": "lvl",
      "level": 32
    },
    {
      "move": "skullbash",
      "how": "lvl",
      "level": 34
    },
    {
      "move": "stockpile",
      "how": "lvl",
      "level": 36
    },
    {
      "move": "finishingblow",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "amnesia",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "metalburst",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "steamroller",
      "how": "lvl",
      "level": 45
    },
    {
      "move": "volttackle",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "electroassault",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "workup",
      "how": "tm"
    },
    {
      "move": "takedown",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "raindance",
      "how": "tm"
    },
    {
      "move": "electricterrain",
      "how": "tm"
    },
    {
      "move": "rocktomb",
      "how": "tm"
    },
    {
      "move": "thunder",
      "how": "tm"
    },
    {
      "move": "thunderbolt",
      "how": "tm"
    },
    {
      "move": "rockslide",
      "how": "tm"
    },
    {
      "move": "retaliate",
      "how": "tm"
    },
    {
      "move": "swordsdance",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "chargebeam",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "taunt",
      "how": "tm"
    },
    {
      "move": "synchronoise",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "suckerpunch",
      "how": "tm"
    },
    {
      "move": "grassknot",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "smartstrike",
      "how": "tm"
    },
    {
      "move": "partingshot",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "flashcannon",
      "how": "tm"
    },
    {
      "move": "bulkup",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "voltswitch",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "rockpolish",
      "how": "tm"
    },
    {
      "move": "toxicspikes",
      "how": "tm"
    },
    {
      "move": "rockclimb",
      "how": "tm"
    },
    {
      "move": "wildcharge",
      "how": "tm"
    },
    {
      "move": "lunge",
      "how": "tm"
    },
    {
      "move": "poisonjab",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "stoneedge",
      "how": "tm"
    },
    {
      "move": "firstimpression",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "superfang",
      "how": "tutor"
    },
    {
      "move": "ironhead",
      "how": "tutor"
    },
    {
      "move": "bounce",
      "how": "tutor"
    },
    {
      "move": "gunkshot",
      "how": "tutor"
    },
    {
      "move": "foulplay",
      "how": "tutor"
    },
    {
      "move": "gravity",
      "how": "tutor"
    },
    {
      "move": "magnetrise",
      "how": "tutor"
    },
    {
      "move": "irondefense",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "electroweb",
      "how": "tutor"
    },
    {
      "move": "zenheadbutt",
      "how": "tutor"
    },
    {
      "move": "irontail",
      "how": "tutor"
    },
    {
      "move": "snore",
      "how": "tutor"
    },
    {
      "move": "roleplay",
      "how": "tutor"
    },
    {
      "move": "shockwave",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "endeavor",
      "how": "tutor"
    },
    {
      "move": "stealthrock",
      "how": "tutor"
    },
    {
      "move": "stompingtantrum",
      "how": "tutor"
    }
  ],
  "ribombeetotem": [
    {
      "move": "airslash",
      "how": "lvl",
      "level": 0
    },
    {
      "move": "stunspore",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "megadrain",
      "how": "lvl",
      "level": 1
    },
    {
      "move": "silvergale",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "pixiedust",
      "how": "lvl",
      "level": 5
    },
    {
      "move": "siphon",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "drainingkiss",
      "how": "lvl",
      "level": 10
    },
    {
      "move": "aircutter",
      "how": "lvl",
      "level": 12
    },
    {
      "move": "strugglebug",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "disarmingvoice",
      "how": "lvl",
      "level": 14
    },
    {
      "move": "sweetscent",
      "how": "lvl",
      "level": 16
    },
    {
      "move": "charm",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "befriend",
      "how": "lvl",
      "level": 21
    },
    {
      "move": "airslash",
      "how": "lvl",
      "level": 23
    },
    {
      "move": "aromaticmist",
      "how": "lvl",
      "level": 28
    },
    {
      "move": "strengthsap",
      "how": "lvl",
      "level": 30
    },
    {
      "move": "bugbuzz",
      "how": "lvl",
      "level": 33
    },
    {
      "move": "stickyweb",
      "how": "lvl",
      "level": 38
    },
    {
      "move": "moonblast",
      "how": "lvl",
      "level": 40
    },
    {
      "move": "heartswap",
      "how": "lvl",
      "level": 42
    },
    {
      "move": "sleeppowder",
      "how": "lvl",
      "level": 44
    },
    {
      "move": "whirlwind",
      "how": "lvl",
      "level": 46
    },
    {
      "move": "quiverdance",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "batonpass",
      "how": "lvl",
      "level": 48
    },
    {
      "move": "bugbomber",
      "how": "lvl",
      "level": 50
    },
    {
      "move": "revelationdance",
      "how": "lvl",
      "level": 52
    },
    {
      "move": "fleurcannon",
      "how": "lvl",
      "level": 54
    },
    {
      "move": "blossomdance",
      "how": "lvl",
      "level": 56
    },
    {
      "move": "eternalbeam",
      "how": "lvl",
      "level": 60
    },
    {
      "move": "powder",
      "how": "lvl",
      "level": 68
    },
    {
      "move": "weatherball",
      "how": "tm"
    },
    {
      "move": "hiddenpower",
      "how": "tm"
    },
    {
      "move": "nastyplot",
      "how": "tm"
    },
    {
      "move": "rest",
      "how": "tm"
    },
    {
      "move": "lightscreen",
      "how": "tm"
    },
    {
      "move": "sleeptalk",
      "how": "tm"
    },
    {
      "move": "sunnyday",
      "how": "tm"
    },
    {
      "move": "solarbeam",
      "how": "tm"
    },
    {
      "move": "energyball",
      "how": "tm"
    },
    {
      "move": "grassyterrain",
      "how": "tm"
    },
    {
      "move": "reflect",
      "how": "tm"
    },
    {
      "move": "substitute",
      "how": "tm"
    },
    {
      "move": "agility",
      "how": "tm"
    },
    {
      "move": "endure",
      "how": "tm"
    },
    {
      "move": "aurasphere",
      "how": "tm"
    },
    {
      "move": "playrough",
      "how": "tm"
    },
    {
      "move": "gigaimpact",
      "how": "tm"
    },
    {
      "move": "acrobatics",
      "how": "tm"
    },
    {
      "move": "naturalgift",
      "how": "tm"
    },
    {
      "move": "calmmind",
      "how": "tm"
    },
    {
      "move": "naturepower",
      "how": "tm"
    },
    {
      "move": "uturn",
      "how": "tm"
    },
    {
      "move": "hyperbeam",
      "how": "tm"
    },
    {
      "move": "psychic",
      "how": "tm"
    },
    {
      "move": "dazzlinggleam",
      "how": "tm"
    },
    {
      "move": "hurricane",
      "how": "tm"
    },
    {
      "move": "focusblast",
      "how": "tm"
    },
    {
      "move": "protect",
      "how": "tm"
    },
    {
      "move": "bugbiting",
      "how": "tutor"
    },
    {
      "move": "covet",
      "how": "tutor"
    },
    {
      "move": "signalbeam",
      "how": "tutor"
    },
    {
      "move": "lastresort",
      "how": "tutor"
    },
    {
      "move": "tailwind",
      "how": "tutor"
    },
    {
      "move": "gigadrain",
      "how": "tutor"
    },
    {
      "move": "afteryou",
      "how": "tutor"
    },
    {
      "move": "helpinghand",
      "how": "tutor"
    },
    {
      "move": "trick",
      "how": "tutor"
    },
    {
      "move": "magicroom",
      "how": "tutor"
    },
    {
      "move": "wonderroom",
      "how": "tutor"
    },
    {
      "move": "skillswap",
      "how": "tutor"
    },
    {
      "move": "telekinesis",
      "how": "tutor"
    },
    {
      "move": "allyswitch",
      "how": "tutor"
    },
    {
      "move": "defog",
      "how": "tutor"
    }
  ]
}